import { useMemo } from 'react';
import { store } from 'Utilities/store';
import partnersConfig from '../config/partnersConfig';
import useCommercialApiAuth from './partners/commercialapi/useCommercialApiAuth';
import useInsuletAuth from './partners/insulet/useInsuletAuth';
import useInsuletError from './partners/insulet/useInsuletError';
import useAuth from './useAuth';
import useDefaultError from './useDefaultError';
import useStandaloneAuth from './useStandaloneAuth';
const hookByApp = {
  insulet: {
    useAuth: useInsuletAuth,
    useError: useInsuletError
  },
  commercialapi: {
    useAuth: useCommercialApiAuth,
    useError: useDefaultError
  },
  default: {
    useAuth: useAuth,
    useError: useDefaultError
  }
};
const getDisplayActionBarHeader = (app, registrationReturnUri) => {
  if (registrationReturnUri) {
    return false;
  }
  return partnersConfig[app]?.displayActionBarHeader ?? false;
};
const usePartner = () => {
  const {
    env: {
      app,
      pId,
      registration_return_uri
    },
    config: {
      partners
    }
  } = store.getState();
  const {
    useAuth,
    useError
  } = useMemo(() => {
    if (registration_return_uri) {
      return {
        useAuth: useStandaloneAuth,
        useError: useDefaultError
      };
    }
    return hookByApp[app] ?? hookByApp.default;
  }, [app, registration_return_uri]);
  const authHook = useAuth();
  const errorHook = useError();
  const partner = useMemo(() => {
    if (partners) {
      const partner = partners[pId];
      if (partner) {
        return partner;
      }
    }
    return {
      displayName: '',
      website: '',
      type: ''
    };
  }, [pId, partners]);
  return {
    ...authHook,
    ...errorHook,
    displayActionBarHeader: getDisplayActionBarHeader(app, registration_return_uri),
    partner
  };
};
export default usePartner;